import { useEffect, useState } from 'react';
import { getKeycrmOrderStatuses } from '../../../shared/api/orders.services';

// Кеш каталога статусов KeyCRM на время жизни вкладки:
// список нужен и фильтру, и каждой строке списка заказов.
let cachedStatuses = null;
let pendingPromise = null;

export const loadKeycrmStatuses = () => {
    if (cachedStatuses) return Promise.resolve(cachedStatuses);

    if (!pendingPromise) {
        pendingPromise = getKeycrmOrderStatuses()
            .then((data) => {
                cachedStatuses = Array.isArray(data?.items) ? data.items : [];
                return cachedStatuses;
            })
            .catch((error) => {
                console.error('Error loading KeyCRM statuses:', error);
                pendingPromise = null;
                return [];
            });
    }

    return pendingPromise;
};

export const useKeycrmStatuses = () => {
    const [statuses, setStatuses] = useState(cachedStatuses || []);

    useEffect(() => {
        let ignore = false;

        loadKeycrmStatuses().then((items) => {
            if (!ignore) setStatuses(items);
        });

        return () => {
            ignore = true;
        };
    }, []);

    return statuses;
};
